export const userURI = '/api/user'
export const adminURI = '/api/admin'
export const commonURI = '/api'
